module.exports = __webpack_public_path__ + "svg_80x80/scala.f8add6.svg";